import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../../restServiceConnection';

const ENDPOINT = '/census-photos';

export class CensusPhotosService extends RestServiceConnection {


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES DELETE PHOTO
     * @EN ELIMINAR FOTO
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteCensusPhoto = async (id?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: {
                id: id
            },
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES AÑADIR UNA O VARIAS FOTOS AL CENSO
     * @EN ADD ONE OR MORE PHOTOS TO THE CENSUS
     * 
     * @param formData
     */
    // -------------------------------------------------------------------------------------------------------------
    addCensusPhoto = async (formData: FormData) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/add-photos',
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER UNA FOTO POR SU ID
     * @EN GET A PHOTO BY ITS ID
     * 
     * @param id
     */
    // -------------------------------------------------------------------------------------------------------------
    getCensusPhotoById = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: {
                id: id
            },
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES RENDERIZAR UNA FOTO
     * @EN RENDER A PHOTO
     * 
     * @param id
     */
    // -------------------------------------------------------------------------------------------------------------
    renderPhoto = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/render',
            data: {
                id: id
            },
            responseType: 'blob'
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER TODAS LAS FOTOS DE UN CENSO
     * @EN GET ALL PHOTOS OF A CENSUS
     * 
     * @param id
     */
    // -------------------------------------------------------------------------------------------------------------
    getAllPhotosFromCensus = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-all-photos',
            data: {
                id: id
            },
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

}